import { FC, FocusEvent } from 'react';
import { SystemConfig, SystemConfigKey, SystemConfigValueDto } from '@services';
import { Divider, Grid, Stack } from '@mui/material';
import { FormikNumber } from '@components/common';
import { Tr } from '@utils/translation';
import { FormStepQuestion } from '@components/portal/common';
import { useTranslation } from 'react-i18next';

export interface ISystemConfigurationsProps {
	config?: SystemConfig[];
	onChange?: (key: SystemConfigKey, value: SystemConfigValueDto) => void;
}

export const SystemConfigurations: FC<ISystemConfigurationsProps> = ({ config, onChange }) => {
	const { t } = useTranslation('portal');
	const getValue = (cfgKey: SystemConfigKey) => config?.find(({ key }) => key === cfgKey)?.value?.actual;
	const onUpdateValue = (key: SystemConfigKey, e: FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) =>
		getValue(key) !== +e.target.value && onChange?.(key, { actual: +e.target.value });

	return (
		<Stack direction="column" sx={{ paddingX: 0, paddingY: 4 }} spacing={2}>
			<FormStepQuestion title={<Tr.Portal path="configuration.system-config.insert-fuel-prices" />}>
				<Grid container rowSpacing={2} columnSpacing={3}>
					<Grid item xs={6}>
						<FormikNumber
							withoutFormik
							name="gasolinePrice"
							title={`${t('location.gasoline-price')} (€)`}
							placeholder={`${t('location.gasoline-price')} (€)`}
							fullWidth
							required
							value={getValue(SystemConfigKey.GASOLINE_PRICE) || ''}
							onBlur={(e) => onUpdateValue(SystemConfigKey.GASOLINE_PRICE, e)}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormikNumber
							withoutFormik
							name="dieselPrice"
							title={`${t('location.diesel-price')} (€)`}
							placeholder={`${t('location.diesel-price')} (€)`}
							fullWidth
							required
							value={getValue(SystemConfigKey.DIESEL_PRICE) || ''}
							onBlur={(e) => onUpdateValue(SystemConfigKey.DIESEL_PRICE, e)}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormikNumber
							withoutFormik
							name="gplPrice"
							title={`${t('location.gpl-price')} (€)`}
							placeholder={`${t('location.gpl-price')} (€)`}
							fullWidth
							required
							value={getValue(SystemConfigKey.GPL_PRICE) || ''}
							onBlur={(e) => onUpdateValue(SystemConfigKey.GPL_PRICE, e)}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormikNumber
							withoutFormik
							name="naturalGasPrice"
							title={`${t('location.natural-gas-price')} (€)`}
							placeholder={`${t('location.natural-gas-price')} (€)`}
							fullWidth
							required
							value={getValue(SystemConfigKey.NATURAL_GAS_PRICE) || ''}
							onBlur={(e) => onUpdateValue(SystemConfigKey.NATURAL_GAS_PRICE, e)}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormikNumber
							withoutFormik
							name="electricityPrice"
							title={`${t('location.electricity-price')} (€)`}
							placeholder={`${t('location.electricity-price')} (€)`}
							fullWidth
							required
							value={getValue(SystemConfigKey.ELECTRICITY_PRICE) || ''}
							onBlur={(e) => onUpdateValue(SystemConfigKey.ELECTRICITY_PRICE, e)}
						/>
					</Grid>
				</Grid>
			</FormStepQuestion>
			<Divider light />
		</Stack>
	);
};
